import {
  Button,
  Icon,
  Input,
  Spin,
  Table,
  Row,
  Dropdown,
  Menu,
  Upload,
  Popconfirm,
  Empty,
} from "antd";
import React, { Fragment } from "react";
import Highlighter from "react-highlight-words";
import "../../components/general/drawer/AdaptiveDrawer.css";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { AccountService } from "../../services/account/AccountService";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import history from "../../utils/history";
import { FileService } from "../../services/file/FileService";
import { Translation } from "react-i18next";
import { showSuccessToast, showErrorToast } from "../general/ToastHelper";
import i18next from "i18next";
class ManageAccountNumbers extends React.Component {
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("manageAccountNumbers");
    this.fileService = new FileService();
    this.accountService = new AccountService();
    this.state = {
      isFetching: false,
      searchText: "",
      data: [],
      account: {},
      cfg: {},
      isFetching: false,
      formLayout: "inline",
      loading: false,
      inputVisible: false,
      inputValue: "",
      tags: [],
      packages: [],
      accountNumbers: [],
      enableDelete: true,
    };
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <Translation>
        {(t) => (
          <div style={{ padding: 8 }}>
            <Input
              ref={(node) => {
                this.searchInput = node;
              }}
              placeholder={i18next.t(`Search ${dataIndex}`)}
              value={selectedKeys[0]}
              onChange={(e) =>
                setSelectedKeys(e.target.value ? [e.target.value] : [])
              }
              onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
              style={{ width: 188, marginBottom: 8, display: "block" }}
            />
            <Button
              type="primary"
              onClick={() => this.handleSearch(selectedKeys, confirm)}
              icon="search"
              size="small"
              style={
                this.props.context.curr_dir === "ltr" &&
                this.props.context.curr_lang === "en"
                  ? { width: 100, marginRight: 8 }
                  : { width: 100, marginLeft: 8 }
              }
            >
              {t("Search")}
            </Button>
            <Button
              onClick={() => this.handleReset(clearFilters)}
              size="small"
              style={{ width: 80 }}
            >
              {t("Reset")}
            </Button>
          </div>
        )}
      </Translation>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: "#d73a31" }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] != null &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text}
      />
    ),
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  componentDidMount() {
    // this.getAllAccountMSISDN();
    this.getAccountData();
  }

  async getAccountData() {
    let { id } = this.props.match.params;
    let { isFetching } = this.state;
    this.acc = new AccountService();
    try {
      this.setState({ isFetching: true });
      let account = await this.acc.getAccountsByIdService(
        this.props.context.session_id,
        id
      );
      var cfg = {};
      cfg.pkg_name = "";
      cfg.agents_max_num = "";
      cfg.account_numbers = [];

      if (account.ivrCustomEntityObject.cfg.length) {
        account.ivrCustomEntityObject.cfg.forEach((element) => {
          if (Object.getOwnPropertyNames(element).indexOf("PKG_NAME") > -1) {
            cfg.pkg_name = element["PKG_NAME"];
          }
          if (
            Object.getOwnPropertyNames(element).indexOf("AGENTS_MAX_NUMBER") >
            -1
          ) {
            cfg.agents_max_num = element["AGENTS_MAX_NUMBER"];
          }
          if (
            Object.getOwnPropertyNames(element).indexOf("ACCOUNT_NUMBERS") > -1
          ) {
            if (element["ACCOUNT_NUMBERS"] === "") {
              cfg.account_numbers = [];
            } else {
              cfg.account_numbers = element["ACCOUNT_NUMBERS"].split(",");
            }
          }
        });
      }
      this.setState({
        account: account.ivrCustomEntityObject,
        isFetching: false,
        cfg: cfg,
        tags: cfg.account_numbers,
      });
      let data = [];
      if (cfg.account_numbers.length == 1) {
        this.state.enableDelete = false;
      }
      for (var i = 0; i < cfg.account_numbers.length; i++) {
        data.push({ msisdn: cfg.account_numbers[i], status: "RES" });
      }
      this.setState({ data: this.formatData(data), isFetching: false });
    } catch (error) {
      this.setState({
        isFetching: false,
      });
      handleError(error);
    }
  }

  formatData(data) {
    const updated_data = [];
    for (var i = 0; i < data.length; i++) {
      var row = {};
      row["key"] = i + 1;
      row["msisdn"] = data[i]["msisdn"];
      row["status"] = data[i]["status"] == "ACT" ? i18next.t("Active") : i18next.t("Reserved");
      updated_data.push(row);
    }
    return updated_data;
  }

  renderActionDropdown(record) {
    const menu = (
      <Menu>
        <Menu.Item>
          <Popconfirm
            title={i18next.t("Are you sure delete this Account Number?")}
            onConfirm={() => this.deleteAccountNumber(record)}
            okText={i18next.t("Yes")}
            cancelText={i18next.t("No")}
          >
            <a href="#" style={{ color: "rgba(0, 0, 0, 0.65)" }}>
              {i18next.t("Delete")}
              <Icon className={"delete-account-style"} type="delete" />
            </a>
          </Popconfirm>
        </Menu.Item>
      </Menu>
    );
    return (
      <Dropdown overlay={menu}>
        <Button size="small" style={{ borderWidth: 0 }}>
          <Icon item={record} type="more" />
        </Button>
      </Dropdown>
    );
  }

  async handleDownload() {
    try {
      let response = await this.fileService.downloadMsisdnTemp(
        this.props.context.session_id,
        "CSV"
      );
    } catch (e) {
      handleError(e);
    }
  }

  async deleteAccountNumber(record) {
    let { id } = this.props.match.params;

    if (this.state.enableDelete) {
      try {
        let data = await this.accountService.deleteBIVRNumber(
          this.props.context.session_id,
          { accountId: id, BIVRNumber: record.msisdn }
        );
        showSuccessToast(i18next.t("Deleted successfully"));
        this.handleRefresh();
      } catch (e) {
        handleError(e);
      }
    } else {
      var error = {
        message: i18next.t("this account number cannot be deleted"),
      };
      handleError(error);
    }
  }

  addAccountMSISDN = () => {
    let { id } = this.props.match.params;
    history.push(`/home/accounts/addAccountNumbers/${id}`);
  };

  handleRefresh() {
    //    this.getAllAccountMSISDN();
    this.getAccountData();
  }

  handleCancel = () => {
    this.setState({
      file: null,
      uploading: false,
    });
  };
  itemRender = (current, type, originalElement) => {
    if (type === "prev") {
      return (
        <a className="ant-pagination-item-link">
          <Icon
            type={this.props.context.curr_dir === "rtl" ? "right" : "left"}
          />
        </a>
      );
    }
    if (type === "next") {
      return (
        <a className="ant-pagination-item-link">
          <Icon
            type={this.props.context.curr_dir === "rtl" ? "left" : "right"}
          />
        </a>
      );
    }
    return originalElement;
  };

  handleUpload = async () => {
    this.setState({
      uploading: true,
    });

    let session_id = this.props.context.session_id;

    try {
      let response = await this.fileService.uploadMsisdnBatch(
        session_id,
        this.state.file
      );
      this.setState({
        file: null,
        uploading: false,
      });
      showSuccessToast(i18next.t("uploaded successfully"));
      this.getAllAccountMSISDN();
    } catch (e) {
      this.setState({
        uploading: false,
      });
      handleError(e);
    }
  };

  render() {
    const columns = [
      {
        title: i18next.t("Account Number"),
        dataIndex: "msisdn",
        key: "msisdn",
        width: "40%",
        ...this.getColumnSearchProps("msisdn"),
      },
      {
        title: i18next.t("Status"),
        dataIndex: "status",
        key: "status",
        width: "40%",
      },
      {
        title: i18next.t("Action"),
        dataIndex: "operation",
        render: (text, record) =>
          this.state.data.length >= 1
            ? this.renderActionDropdown(record)
            : null,
      },
    ];
    const { uploading, file } = this.state;
    const props = {
      showUploadList: false,
      beforeUpload: (file) => {
        const isCsv = file.type === ".csv" || file.type === "text/csv";
        if (!isCsv) {
          showErrorToast(i18next.t("You can only upload CSV file!"));
          return;
        }
        this.setState((state) => ({
          file: file,
        }));
        return false;
      },
      file,
    };
    let { isFetching } = this.state;
    return (
      <Translation>
        {(t) => (
          <Page title={t("Manage Business IVR Numbers")}>
            {isFetching ? (
              <Spin></Spin>
            ) : (
              <div>
                {/* <Row style={{ marginTop: "25px" }}>
                <Button
                  icon="download"
                  onClick={() => this.handleDownload()}
                  style={{ marginRight: "20px", marginBottom: "25px" }}
                > Download Template</Button>
                <Upload {...props}>
                  <Button style={{ marginRight: "20px", marginBottom: "25px" }}>
                    <Icon type="upload" style={{ color: "" }} />
                    {this.state.file === null
                      ? "Upload Batch"
                      : this.state.file.name}
                  </Button>
                </Upload>
                {this.state.file === null ? null : (
                  <Fragment>
                    <Button
                      icon="delete"
                      className="button-delete"
                      onClick={this.handleCancel}
                      style={{ marginRight: "20px", marginBottom: "25px" }}
                    ></Button>
  
                    <Button
                      type="primary"
                      onClick={this.handleUpload}
                      loading={uploading}
                    >
                      {uploading ? "Uploading" : "Start Upload"}
                    </Button>
                  </Fragment>
                )}
              </Row> */}
                <Row>
                  <Button
                    className="button-add-account"
                    onClick={this.addAccountMSISDN}
                    icon="plus"
                  />
                  <span>{t("Add Business IVR Number")}</span>
                </Row>

                <Table
                  columns={columns}
                  bodyStyle={{
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                    borderRadius: "8px",
                    marginBottom: "25px",
                  }}
                  dataSource={this.state.data}
                  pagination={{
                    position: "bottom",
                    pageSize: 10,
                    itemRender: this.itemRender,
                  }}
                  bordered
                  locale={{
                    emptyText: (
                      <Empty
                        description={i18next.t("Empty")}
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                      />
                    ),
                  }}
                />
              </div>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}
  
  export default withSharedStateConsumer(ManageAccountNumbers);
  